import axios from 'axios';
import store from './store';
import eventBus from './utils/eventBus';

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use((config) => {
  if (store.state.auth.accessToken !== null) {
    config.headers.Authorization = `Basic ${store.state.auth.accessToken}`; // eslint-disable-line no-param-reassign
  }
  return config;
});

http.interceptors.response.use((response) => response, (error) => {
  const { config, response } = error;
  if (error.response && error.response.status === 400) {
    if (error.response.data.error !== 'invalid_grant') {
      eventBus.$emit(
        'error400',
        error.response.data,
      );
    }
  } else if (error.response && (error.response.status !== 401) && (error.response.status !== 404)) {
    eventBus.$emit(
      'error500',
      error.response.data,
    );
  }
  if (response && response.status === 401 && !config.url.includes('printer/authorize') && !config.url.includes('printer/customer')) {
    store.dispatch('auth/logout');
  }
  if (response && response.status === 401 && config.url.includes('printer/customer')) {
    store.dispatch('auth/customer401');
  }
  if (response && response.status === 403 && config.url.includes('printer/customer')) {
    store.dispatch('auth/customer403');
  }
  if (!error.response && !axios.isCancel(error)) {
    eventBus.$emit(
      'errorNetwork',
      {
        message: 'Selhalo připojení k serveru. Opakujte akci později',
      },
    );
  }
  return Promise.reject(error);
});

export default http;
